import { render, staticRenderFns } from "./warehousePerform.vue?vue&type=template&id=5389f0f2&scoped=true&"
import script from "./warehousePerform.vue?vue&type=script&lang=js&"
export * from "./warehousePerform.vue?vue&type=script&lang=js&"
import style0 from "./warehousePerform.vue?vue&type=style&index=0&id=5389f0f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5389f0f2",
  null
  
)

export default component.exports